import {
  // UIMenuItem,
  UITab
} from '@constants';
// import { useCheckScreenWithCallback } from '@hooks';
import React, { memo, useCallback, useRef, useState } from 'react';
import trans from 'translation';
import { KBreadcrumbs, KContainer, KTab, KTabInstance } from 'uikit';
import { useMount } from 'uikit-common';

import Accounting from './Accounting';
import Operation from './Operation';

const SEARCH_PARAMS_KEY = 'tab';

const ReportV2 = () => {
  const tabRef = useRef<KTabInstance>(null);

  const [tabIndex, setTabIndex] = useState(0);

  const cb = useCallback(() => {
    const _tabs = [
      {
        code: UITab.ReportOperations,
        label: trans('operation')
      },
      {
        code: UITab.ReportAccounting,
        label: trans('accounting')
      }
    ];

    return _tabs;
  }, []);

  const tabs = cb();

  useMount(() => {
    const url = new URL(window.location as any);
    if (!url.searchParams.has(SEARCH_PARAMS_KEY)) {
      url.searchParams.append(SEARCH_PARAMS_KEY, UITab.ReportOperations);
      window.history.replaceState({}, '', url);
    }
    const _tabIndex = tabs?.findIndex(
      i => i.code === url.searchParams.get(SEARCH_PARAMS_KEY)
    );

    tabRef?.current?.onChange(_tabIndex ?? 0);
  });

  const onChangeTab = useCallback(
    (_idx: number) => {
      setTabIndex(_idx);
      const url = new URL(window.location as any);
      const _tabName = url.searchParams.get(SEARCH_PARAMS_KEY);

      if (!_tabName) {
        url.searchParams.append(SEARCH_PARAMS_KEY, tabs?.[_idx]?.code);
      } else {
        url.searchParams.set(SEARCH_PARAMS_KEY, tabs?.[_idx]?.code);
      }

      window.history.replaceState({}, '', url);
    },
    [tabs]
  );
  //   const tabs = useCheckScreenWithCallback(cb, UIMenuItem.Report);

  return (
    <>
      <KBreadcrumbs
        breadcrumbs={[trans('routes.report'), trans('routes.operation')]}
        hasBackIcon={false}
      />

      <KContainer.View padding="0.75rem">
        <KTab.White
          ref={tabRef}
          tabIndex={tabIndex}
          onChangeTab={onChangeTab}
          tabs={tabs}
        />

        <KTab.Panel
          value={tabIndex}
          index={tabs.findIndex(i => i.code === UITab.ReportOperations)}
        >
          <Operation />
        </KTab.Panel>

        <KTab.Panel
          value={tabIndex}
          index={tabs.findIndex(i => i.code === UITab.ReportAccounting)}
        >
          <Accounting />
        </KTab.Panel>
      </KContainer.View>
    </>
  );
};

export default memo(ReportV2);
